<label class="label">
  {{ label() }}
  <span class="hint">{{ hint() }}</span>
</label>

<div
  *ngFor="let option of options(); let idx = index"
  [style.padding]="padding()"
  [style.border-bottom]="borderBottom()"
  [style.border]="border()"
  [style.borderRadius]="borderRadius()"
  [style.width]="width()">
  <label class="container" [formGroup]="formGroup()">
    <input
      [id]="id() + '_label_' + idx"
      type="radio"
      class="radio"
      [attr.name]="inputFormControlName()"
      [value]="option?.value || option?.key"
      [formControlName]="inputFormControlName()" />
    <span class="checkmark"></span>
    <span *ngIf="label()" class="container__content">{{ option?.label }}</span>
  </label>
</div>
